









































































































import { Vue } from "../../constants/constants";
import { constants } from "http2";
import {
  BasketLoadersEnum,
  genericErrorsEnum
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("reorder-modal", {
  data() {
    return {
      staticContent,
      hasError: false,
      basketLoader: BasketLoadersEnum
    };
  },
 
  computed: {
    // flattenDeliveryZones(){
    // return  this.$root.flattenDeliveryZones;

    // },
    // areaZones(){
    // return  this.$root.areaZones;

    // },
    // flattenDeliveryAreaZones(){
    // return  this.$root.flattenDeliveryAreaZones;

    // },
    // deliveryAreaZones(){
    // return  this.$root.deliveryAreaZones;
    // },
    // areaSearchText(){
    // return  this.$root.areaSearchText;

    // },
    // areaZonesSelected(){
    // return  this.$root.areaZonesSelected;

    // },
    bindConditionalClasses(){
    return  this.$root.bindConditionalClasses;
    },
    isGuest(){
    return  this.$root.isGuest;

    },
    basket() {
      return this.$store.getters.getBasket;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    },
     profile() {
      return this.$store.getters.getProfileData;
    },
     basketisGroup() {
        return this.$store.state.basketCompact.data.isGroup;
      },
  },
  methods: {
    // addAreaZoneForReOrder(areaUuid,zoneUuid){
    //   this.$root.addAreaZoneForReOrder(areaUuid,zoneUuid);

    // },
    // areaZonesChangeHandler(areaUuid){
    //   this.$root.areaZonesChangeHandler(areaUuid);

    // },
    // updateScroll(id){
    //   this.$root.updateScroll(id);
    // },
    // removeSelectedArea(){
    //   this.$root.removeSelectedArea();

    // },
    tabsHandler(form,btn){
      this.$root.tabsHandler(form, btn);
    },
    hideModal() {
      this.$root.modalToggler('re-order-modal', 'hide');
    },
  
  }
});
